export enum Roles {
  operation = "OPERATION",
  manager = "MANAGER",
  anti_fraud = "ANTI_FRAUD",
  finance = "FINANCE",
  credit = "CREDIT",
  help_desk = "HELP_DESK",
  customer_care = "CUSTOMER_CARE",
  compliance = "COMPLIANCE",
  compliance_manager = "COMPLIANCE_MANAGER",
  admin = "ADMIN",
}

export enum GroupAdmin {
  ANTI_FRAUD_ADMIN = "ANTI_FRAUD_ADMIN",
  COMPLIANCE_ADMIN = "COMPLIANCE_ADMIN",
  CREDIT_ADMIN = "CREDIT_ADMIN",
  CUSTOMER_CARE_ADMIN = "CUSTOMER_CARE_ADMIN",
  FINANCE_ADMIN = "FINANCE_ADMIN",
  OPERATION_ADMIN = "OPERATION_ADMIN"
}

export enum PayoutStatus {
  READY_FOR_NEW = "READY_FOR_NEW",
  ANB_PAYOUT_PROCESSING = "ANB_PAYOUT_PROCESSING",
  PENDING_FOR_APPROVAL = "PENDING_FOR_APPROVAL",
  PENDING_FOR_FINANCE_APPROVAL = "PENDING_FOR_FINANCE_APPROVAL",
  APPROVED_FROM_FINANCE = "APPROVED_FROM_FINANCE",
  REJECTED_FROM_FINANCE = "REJECTED_FROM_FINANCE",
  PROCESSING = "PENDING_FOR_FINANCE_APPROVAL",
  SUCCESSFUL = "SUCCESSFUL",
  FAILED = "FAILED",

  //Below status are applicable only for the ANB payment channel type.
  APPROVED = "APPROVED",
  REJECTED = "REJECTED",
  QUEUED = "QUEUED",
  PAYOUT_PROCESSING = "PROCESSING"
}

export enum PaymentProvider {
  ANB_PAY = "ANB_PAY",
  HYPER_PAY = "HYPER_PAY",
}

export enum PaymentStatus {
  ALL = "ALL",
  SUCCESS = "SUCCESS",
  REJECTED = "REJECTED",
  PENDING = "PENDING",
  INITIATED = "INITIATED",
}

export enum AmlockStatus {
  ALL = "ALL",
  APPROVED = "APPROVED",
  REJECTED = "REJECTED",
  INVALID = "INVALID",
  APPROVED_BY_AMLOCK = "APPROVED_BY_AMLOCK",
  APPROVED_BY_COMPLIANCE = "APPROVED_BY_COMPLIANCE",
  NEED_COMPLIANCE_ACTION = "NEED_COMPLIANCE_ACTION",
  REJECTED_BY_COMPLIANCE = "REJECTED_BY_COMPLIANCE",
}

export enum PEPStatus {
  ALL = "ALL",
  APPROVED = "APPROVED",
  REJECTED = "REJECTED",
  PENDING = "PENDING",
  CHECKED = "CHECKED",
  YES = "TRUE",
  NO = "FALSE",
}

export enum RelatedPartiesStatus {
  ALL = "ALL",
  APPROVED = "APPROVED",
  REJECTED = "REJECTED",
  PENDING = "PENDING",
}

export enum RouterPath {
  CUSTOMER_ROUTE = "/customers",
  APP_SETTINGS_ROUTE = "/app_settings",
  LOANS_ROUTE = "/loans",
  FUNNEL_MONITORING_ROUTE = "/funnel-monitoring",
  PAYOUT_FINANCE_ROUTE = "/payouts-finance",
  STATEMENTS_ROUTE = "/statements",
  PAYOUT_CREDIT_ROUTE = "/payouts-credit",
  REPORTS_ROUTE = "/reports",
  DASH_REPORT = "/dashboard",
  PAYMENT_ROUTE = "/payments",
  AML = "/aml",
  PEP = "/pep",
  RELATED_PARTIES = "/related-parties",
  MANUAL_SALARY = "/manual-salary"
}

export enum PayoutPageType {
  CREDIT = "CREDIT",
  FINANCE = "FINANCE",
}
export const ALL = "ALL";

export const PROFILE_KEY = "profile";
export const SESSOIN_EXPIRY_KEY = "session_expiry";
export const LAST_ACTIVITY_KEY = "last_activity";
export const IDLE_TIMEOUT_MS = 15 * 60 * 1000;
export const IDLE_WARNING_MS = 2 * 60 * 1000;
export const supportEmail = "support@QuaraFinance.com";

export enum ManualSalarystatus {
  APPROVED = "APPROVED",
  REJECTED = "REJECTED",
  PENDING = "PENDING"
}